const parseHiddenStaffIds = () => {
  const raw = process.env.REACT_APP_PROJECT_TRACKER_HIDDEN_STAFF_IDS || ''

  return raw
    .split(',')
    .map((value) => value.trim())
    .filter(Boolean)
}

export const HIDDEN_PROJECT_TRACKER_STAFF_IDS = parseHiddenStaffIds()

export const getProjectTrackerStaffId = (staff) => {
  return staff?.staff_id ?? staff?.id ?? null
}

export const isHiddenProjectTrackerStaff = (staff) => {
  const id = getProjectTrackerStaffId(staff)
  if (id == null) return false
  return HIDDEN_PROJECT_TRACKER_STAFF_IDS.includes(String(id))
}

export const filterVisibleProjectTrackerStaff = (list = []) => {
  return list.filter((staff) => !isHiddenProjectTrackerStaff(staff))
}
